import { render } from "./BiosampleSelection.vue?vue&type=template&id=aec96596"
import script from "./BiosampleSelection.vue?vue&type=script&lang=js"
export * from "./BiosampleSelection.vue?vue&type=script&lang=js"

import "./BiosampleSelection.vue?vue&type=style&index=0&id=aec96596&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__